"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SignUp_1 = __importDefault(require("./SignUp"));
exports.default = SignUp_1.default;
